(() => {
  if (window.articleTocInitialized) return;
  window.articleTocInitialized = true;

  const mobileQuery = window.matchMedia("(max-width: 989px)");

  let header = null;
  let headerResizeObserver = null;

  function updateHeaderHeight() {
    const height = header
      ? Math.ceil(header.getBoundingClientRect().height)
      : 0;

    document.documentElement.style.setProperty(
      "--article-header-height",
      `${height}px`
    );
  }

  function connectHeader() {
    if (headerResizeObserver) {
      headerResizeObserver.disconnect();
      headerResizeObserver = null;
    }

    header =
      document.querySelector("[data-sc-header]") ||
      document.querySelector("sticky-header") ||
      document.querySelector(".header-wrapper");

    updateHeaderHeight();

    if (header && "ResizeObserver" in window) {
      headerResizeObserver = new ResizeObserver(updateHeaderHeight);
      headerResizeObserver.observe(header);
    }
  }

  function setExpanded(toc, expanded) {
    const toggle = toc.querySelector(".article-toc__toggle");
    const list = toc.querySelector(".article-toc__list");

    if (!list) return;

    // Always show desktop links. Older markup without a toggle
    // also stays accessible.
    const showList = !mobileQuery.matches || !toggle || expanded;

    list.hidden = !showList;

    if (toggle) {
      toggle.setAttribute("aria-expanded", String(showList));
    }
  }

  function initializeArticleTocs(scope = document) {
    const tocs = [...scope.querySelectorAll("[data-article-toc]")];

    if (
      scope instanceof Element &&
      scope.matches("[data-article-toc]")
    ) {
      tocs.unshift(scope);
    }

    tocs.forEach((toc) => {
      const content = document.getElementById(toc.dataset.contentId);
      const list = toc.querySelector(".article-toc__list");
      const toggle = toc.querySelector(".article-toc__toggle");

      toc.hidden = true;

      if (!content || !list) return;

      list.replaceChildren();

      const headings = [...content.querySelectorAll("h2")].filter(
        (heading) => heading.textContent.trim()
      );

      if (headings.length < 2) return;

      if (toggle) {
        toggle.onclick = () => {
          const expanded =
            toggle.getAttribute("aria-expanded") === "true";

          setExpanded(toc, !expanded);
        };
      }

      const reservedIds = new Set(
        [...document.querySelectorAll("[id]")].map(
          (element) => element.id
        )
      );

      const handledIds = new Set();
      const fragment = document.createDocumentFragment();

      headings.forEach((heading, index) => {
        const label = heading.textContent.trim();
        let id = heading.id;

        if (
          !id ||
          handledIds.has(id) ||
          document.getElementById(id) !== heading
        ) {
          const slug =
            label
              .toLowerCase()
              .normalize("NFKD")
              .replace(/[\u0300-\u036f]/g, "")
              .replace(/[^\p{Letter}\p{Number}]+/gu, "-")
              .replace(/^-+|-+$/g, "") ||
            `section-${index + 1}`;

          const base = `${content.id}-${slug}`;
          id = base;

          let suffix = 2;

          while (reservedIds.has(id)) {
            id = `${base}-${suffix++}`;
          }

          heading.id = id;
          reservedIds.add(id);
        }

        handledIds.add(id);

        const headingTag = heading.tagName.toLowerCase();

        const item = document.createElement("li");
        item.className =
          `article-toc__item article-toc__item--${headingTag}`;

        const itemHeading = document.createElement(headingTag);
        itemHeading.className = "article-toc__item-heading";

        const link = document.createElement("a");
        link.href = `#${encodeURIComponent(id)}`;
        link.textContent = label;

        link.addEventListener("click", (event) => {
          if (
            !mobileQuery.matches ||
            !toggle ||
            event.defaultPrevented ||
            event.button !== 0 ||
            event.ctrlKey ||
            event.metaKey ||
            event.shiftKey ||
            event.altKey
          ) {
            return;
          }

          setExpanded(toc, false);

          // Move focus to the destination before hiding its link.
          if (!heading.hasAttribute("tabindex")) {
            heading.setAttribute("tabindex", "-1");

            heading.addEventListener(
              "blur",
              () => heading.removeAttribute("tabindex"),
              { once: true }
            );
          }

          heading.focus({ preventScroll: true });

          // Keep the native link action for the URL hash and scrolling.
        });

        itemHeading.appendChild(link);
        item.appendChild(itemHeading);
        fragment.appendChild(item);
      });

      list.appendChild(fragment);

      // Initially collapsed on mobile and expanded on desktop.
      setExpanded(toc, false);
      toc.hidden = false;
    });
  }

  function initialize() {
    connectHeader();
    initializeArticleTocs();
  }

  mobileQuery.addEventListener("change", () => {
    document.querySelectorAll("[data-article-toc]").forEach((toc) => {
      const toggle = toc.querySelector(".article-toc__toggle");
      const list = toc.querySelector(".article-toc__list");
      const focused = document.activeElement;

      // Move focus out of the list before collapsing it on mobile.
      if (mobileQuery.matches && toggle && list?.contains(focused)) {
        toggle.focus({ preventScroll: true });
      }

      setExpanded(toc, false);

      // Desktop links are now visible and can receive focus.
      if (!mobileQuery.matches && toggle && focused === toggle) {
        list?.querySelector("a")?.focus({ preventScroll: true });
      }
    });
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, {
      once: true
    });
  } else {
    initialize();
  }

  window.addEventListener("resize", updateHeaderHeight, {
    passive: true
  });

  window.addEventListener("load", updateHeaderHeight, {
    once: true
  });

  document.addEventListener("shopify:section:load", (event) => {
    connectHeader();
    initializeArticleTocs(event.target);
  });

  document.addEventListener("shopify:section:unload", () => {
    requestAnimationFrame(connectHeader);
  });
})();